import { toast } from "react-toastify";
import { FADV_API_PACKAGE } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const fetchAIFadvPackageTableAndFilterSchema = async (data = {}) => {
  try {
    const response = await GET(FADV_API_PACKAGE.METADATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitFilterData = async (data = {}) => {
  try {
    const response = await POST(FADV_API_PACKAGE.FILTER, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addAIFadvPackage = async (data = {}) => {
  try {
    const response = await POST(FADV_API_PACKAGE.LIST, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateAIFadvPackage = async (id, data = {}) => {
  try {
    const response = await PUT(FADV_API_PACKAGE.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getAIFadvPackageDataById = async (data = {}) => {
  try {
    const id = data?.Id ?? data?.id;
    const response = await GET(FADV_API_PACKAGE.BY_ID(id), data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
